// `text.shot_list`: one actor's shot list, a step of the Advanced Talking Head's run (#223).
// Live lists no such job; the Advanced Talking Head's run starts it.
import { TextShotListQuote, TextShotListRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"text.shot_list"> = {
  type: "text.shot_list",
  label: "Shot list",
  source: "form",
  pair: "text.shot_list",
  fields: (draft) => commonFields(draft),
  request: TextShotListRequest,
  quote: TextShotListQuote,
};
